import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'
import Checkbox from 'components/Checkbox'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
  ModalSheetSection,
} from 'components/ModalSheet'
import { pluralize } from 'utils/pluralization-util'
import ManageDocumentSignatureItemsViewModel, {
  DocumentSignatureItem,
} from './ManageDocumentSignatureItemsViewModel'
import styles from './ManageDocumentSignatureItemsDialog.sass'

interface ManageDocumentSignatureItemsProps {
  vm: ManageDocumentSignatureItemsViewModel
}

export default observer(function ManageDocumentSignatureItemsDialog({
  vm,
}: ManageDocumentSignatureItemsProps) {
  return (
    <ModalSheet
      disableCloseOnOutsideClick
      showing={vm.showing}
      onRequestClose={vm.close}
    >
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle emphasized>
          Manage document signature items
        </ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetSection spaced>
          <div className={styles.heading}>
            <span>Select all that apply</span>
          </div>
          {vm.documentSignatureItems.map((item, index) => (
            <DocumentSignatureItemSelector key={index} item={item} />
          ))}
        </ModalSheetSection>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            type="default"
            onClick={vm.close}
            dataTest="manage-document-signature-items-close-button"
          >
            Close
          </Button>

          <Button
            type="primary"
            form="addItemForm"
            onClick={vm.submit}
            dataTest="manage-document-signature-items-assign-button"
          >
            {`Assign ${vm.totalSelected} ${pluralize(
              'item',
              vm.totalSelected,
            )}`}
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})

interface DocumentSignatureItemSelectorProps {
  item: DocumentSignatureItem
}

const DocumentSignatureItemSelector = observer(function ({
  item,
}: DocumentSignatureItemSelectorProps) {
  return (
    <div className={styles.documentSignatureItem}>
      <div className={styles.selector}>
        <label className={styles.label}>
          <Checkbox checked={item.selected} onChange={item.toggleSelected} />
          <div className={styles.labelText}>{item.name}</div>
        </label>
      </div>
    </div>
  )
})
